import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";


export type GetMerchantCommissionsByBankResponse = BaseResponse<any>;

async function getMerchantCommissionsByBank(
  data: number
): Promise<any> {
  try {
    return (await axiosInstance.get("/Transaction/ListMerchantCommissionsByBank?merchantId=" + data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantCommissionsByBank() {
  return useMutation<any, Error, number>((variables) =>
  getMerchantCommissionsByBank(variables)
  );
}
